enum LogLevel {
    INFORMATION = 'Information',
    WARNING = 'Warning',
    ERROR = 'Error',
}

export default LogLevel;
